/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Link_SearchInputs */

const en_footer_link_search = /** @type {(inputs: Footer_Link_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search`)
};

const es_footer_link_search = /** @type {(inputs: Footer_Link_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar`)
};

const fr_footer_link_search = /** @type {(inputs: Footer_Link_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechercher`)
};

const de_footer_link_search = /** @type {(inputs: Footer_Link_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suche`)
};

const ja_footer_link_search = /** @type {(inputs: Footer_Link_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`検索`)
};

const zh_footer_link_search = /** @type {(inputs: Footer_Link_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜索`)
};

const ar_footer_link_search = /** @type {(inputs: Footer_Link_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بحث`)
};

const id_footer_link_search = /** @type {(inputs: Footer_Link_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cari`)
};

const it_footer_link_search = /** @type {(inputs: Footer_Link_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerca`)
};

const ru_footer_link_search = /** @type {(inputs: Footer_Link_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поиск`)
};

const pt_footer_link_search = /** @type {(inputs: Footer_Link_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesquisar`)
};

const ko_footer_link_search = /** @type {(inputs: Footer_Link_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`검색`)
};

/**
* | output |
* | --- |
* | "Search" |
*
* @param {Footer_Link_SearchInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const footer_link_search = /** @type {((inputs?: Footer_Link_SearchInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Link_SearchInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_footer_link_search(inputs)
	if (locale === "es") return es_footer_link_search(inputs)
	if (locale === "fr") return fr_footer_link_search(inputs)
	if (locale === "de") return de_footer_link_search(inputs)
	if (locale === "ja") return ja_footer_link_search(inputs)
	if (locale === "zh") return zh_footer_link_search(inputs)
	if (locale === "ar") return ar_footer_link_search(inputs)
	if (locale === "id") return id_footer_link_search(inputs)
	if (locale === "it") return it_footer_link_search(inputs)
	if (locale === "ru") return ru_footer_link_search(inputs)
	if (locale === "pt") return pt_footer_link_search(inputs)
	return ko_footer_link_search(inputs)
});